import { render, staticRenderFns } from "./ThgListAdminView.vue?vue&type=template&id=ae838164&"
import script from "./ThgListAdminView.vue?vue&type=script&lang=ts&"
export * from "./ThgListAdminView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports